import React from 'react';
import { Dropdown, Switch } from 'antd';
import { withTheme, ThemeProps, DefaultTheme } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { BulbFilled, BulbOutlined } from '@ant-design/icons';
import { useTheme } from '@/contexts/Theme';
import AvatarDropDownMenu from './Menu';
import './style.css';

import {
    Container,
    StyledAvatar,
    Notification,
    NotificationIndicator,
    Icon,
} from './styles';

import avatar from '../../../assets/images/avatar_women.svg';
import bill_outline from '../../../assets/images/bell-outline.svg';
import bill_filled from '../../../assets/images/bell-filled.svg';

import { useAuth } from '../../../contexts/Auth';
import { useGetAnnouncementsShopmanager } from '../../../store/Announcement';

const AvatarMenu: React.FC<ThemeProps<DefaultTheme>> = () => {
    const [visible, setVisible] = React.useState(false);

    const { isAdmin } = useAuth();
    const navigation = useNavigate();
    const { theme, toggleTheme } = useTheme();

    const { data } = useGetAnnouncementsShopmanager({
        'filters[isRead]': false,
    });

    return (
        <Container>
            <Switch
                checked={theme === 'dark'}
                onChange={toggleTheme}
                checkedChildren={
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    <BulbFilled />
                }
                unCheckedChildren={
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    <BulbOutlined />
                }
                style={{ marginRight: 30 }}
            />
            {!isAdmin && data && data.data.length > 0 && (
                <Notification onClick={() => navigation('/announcements/view')}>
                    <Icon src={bill_filled} />
                    <NotificationIndicator />
                </Notification>
            )}

            {!isAdmin && data && data.data.length <= 0 && (
                <Notification onClick={() => navigation('/announcements/view')}>
                    <Icon src={bill_outline} />
                </Notification>
            )}

            <Dropdown
                open={visible}
                onOpenChange={setVisible}
                menu={{
                    items: [
                        {
                            key: 'avatar-menu',
                            label: (
                                <AvatarDropDownMenu setVisible={setVisible} />
                            ),
                            style: {
                                backgroundColor: 'transparent',
                                padding: 0,
                            },
                        },
                    ],
                }}
                trigger={['click']}
                placement="bottomLeft"
                rootClassName="avatar-menu-dropdown"
                styles={{
                    itemContent: { background: 'transparent', padding: 0 },
                    root: { background: 'transparent', padding: 0 },
                    item: { background: 'transparent', padding: 0 },
                }}
                arrow
            >
                <StyledAvatar size="default" src={avatar} />
            </Dropdown>
        </Container>
    );
};
export default withTheme(AvatarMenu);
